import { render, staticRenderFns } from "./drawer.vue?vue&type=template&id=a9b73722&"
import script from "./drawer.vue?vue&type=script&lang=js&"
export * from "./drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9b73722')) {
      api.createRecord('a9b73722', component.options)
    } else {
      api.reload('a9b73722', component.options)
    }
    module.hot.accept("./drawer.vue?vue&type=template&id=a9b73722&", function () {
      api.rerender('a9b73722', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/drawer/drawer.vue"
export default component.exports